var account = "アカウント";
var accountSettings = "アカウント設定";
var charging = "充電";
var contactInfo = "連絡先";
var dashboard = "ダッシュボード";
var home = "ホーム";
var myProducts = "マイプロダクト";
var orderHistory = "注文履歴";
var paymentMethod = "お支払方法";
var profileSettings = "プロフィール設定";
var referAndEarn = "ご紹介プログラム";
var signOut = "サインアウト";
var ja_JP = {
	account: account,
	accountSettings: accountSettings,
	charging: charging,
	contactInfo: contactInfo,
	dashboard: dashboard,
	home: home,
	myProducts: myProducts,
	orderHistory: orderHistory,
	paymentMethod: paymentMethod,
	profileSettings: profileSettings,
	referAndEarn: referAndEarn,
	signOut: signOut
};

export { account, accountSettings, charging, contactInfo, dashboard, ja_JP as default, home, myProducts, orderHistory, paymentMethod, profileSettings, referAndEarn, signOut };
